import StorageAbstract from './storage.abstract';

const userStorage = new StorageAbstract(undefined, 'USER');

export default userStorage;
